import React, { Component } from 'react';

const asyncComponent = (importComponent) => (
  class extends Component {
    state = {
      component: null
    };

    componentDidMount() {
      // eslint-disable-next-line promise/catch-or-return
      importComponent()
        .then(cmp => this.setState({ component: cmp.default }));
    }

    render() {
      const C = this.state.component;

      return C ? <C {...this.props} /> : null;
    }
  }
);

export default asyncComponent;
